<div neo-dialog-title-container class="confirmation-modal__header">
  <div class="title-content">
    @if (config.titleIcon; as titleIcon) {
      <span
        class="title-content__icon"
        [class]="'title-content__icon--' + (titleIcon.tone ?? 'danger')"
        aria-hidden="true"
      >
        <cm-icon [name]="titleIcon.name" size="s" />
      </span>
    }

    <div class="title-content__text">
      <h2 neo-dialog-title class="title-content__title">{{ config.title }}</h2>

      @if (config.subtitle) {
        <p class="title-content__subtitle">{{ config.subtitle }}</p>
      }
    </div>
  </div>

  @if (showCloseIcon) {
    <cm-action-button
      class="close-button"
      size="sm"
      iconColor="neutral"
      iconName="close"
      [ariaLabel]="'Close dialog'"
      [title]="'Close dialog'"
      [disabled]="isBusy()"
      [autId]="config.autId + '-close-btn'"
      (click)="dismiss()"
    />
  }
</div>

<div neo-dialog-content class="confirmation-modal__content" [attr.id]="descriptionId">
  @if (config.message) {
    <p class="confirmation-modal__message">{{ config.message }}</p>
  }

  @if (config.items?.length) {
    <ul class="confirmation-modal__items">
      @for (item of config.items; track item) {
        <li class="confirmation-modal__item">{{ item }}</li>
      }
    </ul>
  }

  @if (config.bodyComponent) {
    <ng-container *ngComponentOutlet="config.bodyComponent; inputs: config.bodyInputs" />
  }

  @if (config.bodyTemplate) {
    <ng-container [ngTemplateOutlet]="config.bodyTemplate" />
  }

  @if (config.disclaimer) {
    <div class="confirmation-modal__disclaimer">
      @if (config.disclaimerIcon) {
        <cm-icon [name]="config.disclaimerIcon" size="xs" aria-hidden="true" />
      }
      <p class="confirmation-modal__disclaimer-text">{{ config.disclaimer }}</p>
    </div>
  }
</div>

<div neo-dialog-actions class="confirmation-modal__actions">
  @for (action of actions; track action.autIdSuffix) {
    <cm-button
      [variant]="action.variant ?? 'flat'"
      [color]="action.color ?? 'primary'"
      [disabled]="(action.disabled ?? false) || isBusy()"
      [tooltip]="action.disabled ? (action.disabledReason ?? '') : ''"
      [loading]="runningAction() === action.autIdSuffix"
      [autId]="config.autId + '-' + action.autIdSuffix"
      (click)="run(action)"
    >
      @if (action.icon && action.iconPosition !== 'trailing') {
        <cm-icon [name]="action.icon" size="xs" />
      }

      {{ action.label }}

      @if (action.icon && action.iconPosition === 'trailing') {
        <cm-icon [name]="action.icon" size="xs" />
      }
    </cm-button>
  }
</div>
